import React, { useState, useEffect, useContext, useRef } from 'react';
import { AddBox, Close, CloudDownload, Reorder } from '@mui/icons-material';
import { Alert, Backdrop, Box, CircularProgress, IconButton, Snackbar, Stack, Tooltip, Typography } from '@mui/material';
import { ModalGeneral, Tabla, VisorPDF } from 'ui-component';
import headers from './components/headers';
import LayautContext from 'Context/ContextLayaut';
import AvisoConfirmacion from 'ui-component/AvisoConfirmacion';
import { ServiciosCurso, ModalCostosGrupo } from './components';
import FormActividad from './components/FormActividad';
import ModalPreguntasActividad from './components/ModalPreguntasActividad';
import FormDetalleActividad from './components/FormDetalleActividad';
import FormOrdenar from './components/FormOrdenar';
import FormDependenciaDetalle from './components/FormDependenciaDetalle';
import VistaEnlace from './components/VistaEnlace';

const DetalleActividad = ({ permisos, actividad, onCambioNivel }) => {
    //
    const context = useContext(LayautContext);
    const serviciosCursos = ServiciosCurso();

    const [detalleActividad, setDetalleActividad] = useState([]);
    const [ctl, setCtl] = useState({ estatusCurso: [] });
    const [confirm, setConfirm] = useState({ open: false });
    const [modal, setModal] = useState({ open: false, titulo: '' });
    const [cargando, setCargando] = useState({ open: false });
    const [colaDescargas, setColaDescargas] = useState([]);
    const [descargaActual, setDescargaActual] = useState(null);
    const abortDescargaRef = useRef(null);
    const cancelacionDescargaRef = useRef({ idDetalleActividad: null, cancelada: false });
    // Función helper para completar el progreso al 100%
    const completarProgreso = () => {
        // Simular progreso de 90% a 100% durante la inserción
        let progreso = 90;
        const interval = setInterval(() => {
            progreso += 2;
            if (progreso <= 100) {
                context.mensaje({
                    open: false
                });
            } else {
                clearInterval(interval);
            }
        }, 200);
    };
    // Handle
    const actualizarData = (nuevaCurso = []) => {
        const datausuario = detalleActividad.map((oc) => oc.idDetalleActividad);
        nuevaCurso.forEach((detalleActividadI) => {
            const indice = datausuario.indexOf(detalleActividadI.idDetalleActividad);
            if (indice >= 0) detalleActividad.splice(indice, 1, detalleActividadI);
            else detalleActividad.splice(0, 0, detalleActividadI);
        });
        setDetalleActividad([...detalleActividad]);
    };

    const actualizarDataV2 = (arr) => {
        let nuevoDato = arr[0];
        let arrActual = detalleActividad;

        let indexActual = arrActual.findIndex((x) => x.idDetalleActividad == nuevoDato.idDetalleActividad);

        if (indexActual != -1) {
            arrActual[indexActual] = nuevoDato;
            setDetalleActividad([...arrActual]);
        }
    };

    const quitaData = (nuevoDato) => {
        let arrActual = detalleActividad;

        let indexActual = arrActual.findIndex((x) => x.idDetalleActividad == nuevoDato.idDetalleActividad);

        if (indexActual != -1) {
            arrActual.splice(indexActual, 1);
            setDetalleActividad([...arrActual]);
        }
    };

    const abrirNuevoMaterial = () => () => {
        context.formulario.abrir({
            open: true,
            width: 'md',
            titulo: `Nuevo material para la actividad "${actividad.titulo}"`,
            propsForm: { data: null, ctl: ctl },
            formulario: FormDetalleActividad,
            aceptar: (dataForm) => {
                const dataFormPivote = { ...dataForm };
                const formData = new FormData();
                if (dataFormPivote.archivo && dataFormPivote?.archivo?.length > 0) {
                    dataFormPivote.archivo = dataFormPivote.archivo[0].file;
                    const tipoArchivo = dataFormPivote.archivo.type;
                    if (tipoArchivo.search('video/') >= 0) dataFormPivote.idTipoActividad = 2;
                    else if (tipoArchivo == 'application/pdf') dataFormPivote.idTipoActividad = 4;
                    else if (tipoArchivo.search('image/') >= 0) dataFormPivote.idTipoActividad = 5;
                    else if (tipoArchivo.startsWith('audio/')) {
                        dataFormPivote.idTipoActividad = 8;
                    } else dataFormPivote.idTipoActividad = 6;
                }
                Object.keys(dataFormPivote).forEach((key) => formData.append(key, dataFormPivote[key]));
                formData.append('idActividad', actividad.idActividad);
                formData.append('orden', detalleActividad.length + 1);

                if (dataFormPivote?.archivo?.size > 1900000) {
                    const nombreOriginal = dataFormPivote.archivo.path;
                    formData.delete('archivo');
                    context.formulario.cerrar();
                    serviciosCursos.chunkFile(
                        (res, uidFolderName) => {
                            formData.append('archivo', uidFolderName + '/' + nombreOriginal);
                            formData.append('uidFolderName', uidFolderName);
                            serviciosCursos.insertDetalleActividad(
                                (res) => {
                                    setDetalleActividad(res.detalleActividad);
                                    context.mensaje({ open: false });
                                },
                                formData,
                                {
                                    cargando: true,
                                    isBigFileResponse: true,
                                    uidFolderName: uidFolderName,
                                    hideSuccessMessage: true
                                }
                            );
                        },
                        {},
                        dataFormPivote.archivo
                    );
                } else {
                    serviciosCursos.insertDetalleActividad(
                        (res) => {
                            setDetalleActividad(res.detalleActividad);
                            context.formulario.cerrar();
                        },
                        formData,
                        {
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                        }
                    );
                }
            }
        });
    };
    const abrirOrdenar = () => () => {
        context.formulario.abrir({
            open: true,
            width: 'sm',
            titulo: 'Ordenar Materiales',
            propsForm: { data: { dataOrden: detalleActividad }, ctl: ctl },
            formulario: FormOrdenar,
            aceptar: (dataForm) => {
                if (dataForm.dataOrdenada == undefined) return context.mensaje({ open: true, value: 'No se ha hacho ningun orden' });
                serviciosCursos.updateOrdenMaterial(
                    (res) => {
                        setDetalleActividad(res.detalleActividad);
                        context.formulario.cerrar();
                    },
                    { ...dataForm, idActividad: actividad.idActividad }
                );
                return true;
            }
        });
    };
    const abrirEditarActividadDetalle = (detalleActividad, isVer) => {
        context.formulario.abrir({
            open: true,
            width: 'md',
            isVer: isVer == 1,
            titulo: `${isVer ? '' : 'Editar'} ${detalleActividad.titulo} para la actvidad ${actividad.titulo}`,
            propsForm: {
                data: detalleActividad,
                ctl: ctl,
                isVer
            },
            formulario: FormDetalleActividad,
            aceptar: (dataForm) => {
                const dataFormPivote = { ...dataForm };
                const formData = new FormData();
                if (dataFormPivote.archivo && dataFormPivote.archivo[0] && !dataFormPivote.archivoActivo) {
                    dataFormPivote.archivo = dataFormPivote.archivo[0].file;
                    const tipoArchivo = dataFormPivote.archivo.type;
                    if (tipoArchivo.search('video/') >= 0) dataFormPivote.idTipoActividad = 2;
                    else if (tipoArchivo == 'application/pdf') dataFormPivote.idTipoActividad = 4;
                    else if (tipoArchivo.search('image/') >= 0) dataFormPivote.idTipoActividad = 5;
                    else if (tipoArchivo.startsWith('audio/')) {
                        dataFormPivote.idTipoActividad = 8;
                    } else dataFormPivote.idTipoActividad = 6;
                }
                formData.append('idActividad', actividad.idActividad);
                formData.append('idDetalleActividad', detalleActividad.idDetalleActividad);
                Object.keys(dataFormPivote).map((key) => formData.append(key, dataFormPivote[key]));

                if (dataFormPivote?.archivo?.size > 1900000 && !dataFormPivote.archivoActivo) {
                    const nombreOriginal = dataFormPivote.archivo.path;
                    formData.delete('archivo');
                    context.formulario.cerrar();
                    serviciosCursos.chunkFile(
                        (res, uidFolderName) => {
                            formData.append('archivo', uidFolderName + '/' + nombreOriginal);
                            formData.append('uidFolderName', uidFolderName);
                            serviciosCursos.updateActivivdadDetalle(
                                (res) => {
                                    actualizarDataV2(res.detalleActividad);
                                    // CERRAR MENSAJE AUTOMÁTICO
                                    context.mensaje({ open: false });
                                },
                                formData,
                                {
                                    cargando: true, // CAMBIAR A true PARA MANTENER UI BLOQUEADA
                                    isBigFileResponse: true,
                                    uidFolderName: uidFolderName,
                                    hideSuccessMessage: true
                                }
                            );
                        },
                        {},
                        dataFormPivote.archivo
                    );
                } else {
                    serviciosCursos.updateActivivdadDetalle(
                        (res) => {
                            actualizarDataV2(res.detalleActividad);
                            context.formulario.cerrar();
                        },
                        formData,
                        {
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                        }
                    );
                }
            }
        });
    };

    const limpiarNombreArchivo = (nombre = 'material') =>
        nombre
            .toString()
            .trim()
            .replace(/[\\/:*?"<>|]+/g, '_')
            .replace(/\s+/g, ' ');

    const obtenerExtensionPorMime = (mime = '') => {
        const mapa = {
            'application/pdf': 'pdf',
            'image/jpeg': 'jpg',
            'image/png': 'png',
            'image/gif': 'gif',
            'image/webp': 'webp',
            'video/mp4': 'mp4',
            'video/webm': 'webm',
            'audio/mpeg': 'mp3',
            'audio/wav': 'wav',
            'audio/ogg': 'ogg',
            'application/zip': 'zip',
            'application/x-zip-compressed': 'zip',
            'application/msword': 'doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
            'application/vnd.ms-excel': 'xls',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
            'text/plain': 'txt'
        };
        return mapa[mime] || '';
    };

    const obtenerExtensionPorUrl = (url = '') => {
        try {
            const sinQuery = url.split('?')[0];
            const nombre = sinQuery.split('/').pop() || '';
            const partes = nombre.split('.');
            if (partes.length > 1) return partes.pop().toLowerCase();
            return '';
        } catch (error) {
            return '';
        }
    };

    const descargarArchivo = async (data, signal) => {
        const url = data?.linkVideo;
        if (!url) {
            context.mensaje({ open: true, status: -1, value: 'No se encontró un archivo para descargar.' });
            return { cancelado: false };
        }

        try {
            const response = await fetch(url, { signal });
            if (!response.ok) throw new Error('No se pudo descargar el archivo');

            const blob = await response.blob();
            const extension = obtenerExtensionPorUrl(url) || obtenerExtensionPorMime(blob.type) || 'bin';
            const nombreBase = limpiarNombreArchivo(data?.titulo || 'material');
            const nombreArchivo = nombreBase.toLowerCase().endsWith(`.${extension}`) ? nombreBase : `${nombreBase}.${extension}`;

            const objectUrl = window.URL.createObjectURL(blob);
            const enlace = document.createElement('a');
            enlace.href = objectUrl;
            enlace.download = nombreArchivo;
            document.body.appendChild(enlace);
            enlace.click();
            document.body.removeChild(enlace);
            window.URL.revokeObjectURL(objectUrl);
            return { cancelado: false };
        } catch (error) {
            if (error?.name === 'AbortError') return { cancelado: true };
            window.open(url, '_blank', 'noreferrer');
            context.mensaje({
                open: true,
                status: 0,
                value: 'No fue posible forzar el nombre del archivo en esta descarga. Se abrió el recurso directamente.'
            });
            return { cancelado: false };
        }
    };

    const esMaterialTipoArchivo = (idTipoActividad) => [2, 4, 5, 6, 8].includes(Number(idTipoActividad));

    const obtenerDetalleExtra = (idDetalleActividad) =>
        new Promise((resolve) => {
            serviciosCursos.getactividadDetalleExtra((extra) => resolve(extra), { idDetalleActividad });
        });

    const descargarMaterialDesdeTabla = (detalleActividad) => {
        if (!detalleActividad) return;
        setColaDescargas((prev) => [...prev, detalleActividad]);
    };

    const cancelarSolicitudActual = () => {
        if (!descargaActual) return;
        cancelacionDescargaRef.current = { idDetalleActividad: descargaActual.idDetalleActividad, cancelada: true };
        if (abortDescargaRef.current) abortDescargaRef.current.abort();
        context.mensaje({
            open: true,
            status: 0,
            value: `Se canceló la solicitud actual del archivo ${descargaActual.titulo || 'material'}.`
        });
    };

    useEffect(() => {
        if (!descargaActual && colaDescargas.length > 0) {
            const siguiente = colaDescargas[0];
            setDescargaActual(siguiente);
            cancelacionDescargaRef.current = { idDetalleActividad: siguiente.idDetalleActividad, cancelada: false };
            abortDescargaRef.current = new AbortController();

            (async () => {
                try {
                    const extra = await obtenerDetalleExtra(siguiente.idDetalleActividad);
                    if (cancelacionDescargaRef.current.cancelada) return;

                    const material = { ...siguiente, ...extra };
                    if (material?.linkVideo) {
                        await descargarArchivo(material, abortDescargaRef.current.signal);
                    } else {
                        context.mensaje({ open: true, status: -1, value: 'No se encontró un archivo para descargar en este material.' });
                    }
                } finally {
                    abortDescargaRef.current = null;
                    cancelacionDescargaRef.current = { idDetalleActividad: null, cancelada: false };
                    setColaDescargas((prev) => prev.slice(1));
                    setDescargaActual(null);
                }
            })();
        }
    }, [colaDescargas, descargaActual]);

    useEffect(() => {
        return () => {
            if (abortDescargaRef.current) abortDescargaRef.current.abort();
        };
    }, []);

    const traerDatosExtra = (detalleActividad, isVer = 0) => {
        if (['1', '2', '4', '5', '6', '8', '9'].includes(detalleActividad.idTipoActividad))
            serviciosCursos.getactividadDetalleExtra(
                (extra) => {
                    if (detalleActividad.idTipoActividad == 4 && isVer) {
                        setModal({
                            open: true,
                            formulario: VisorPDF,
                            titulo: 'PDF actividad: ' + detalleActividad?.titulo,
                            propsModal: {
                                isBase64: true,
                                data: { ...detalleActividad, ...extra },
                                title: 'PDF actividad: ' + detalleActividad?.titulo
                            }
                        });
                    } else if (detalleActividad.idTipoActividad == 6 && isVer) {
                        descargarArchivo({ ...detalleActividad, ...extra });
                    } else if (detalleActividad.idTipoActividad == 9 && isVer) {
                        setModal({
                            open: true,
                            formulario: VistaEnlace,
                            titulo: 'Vista previa: ' + detalleActividad?.titulo,
                            propsModal: {
                                data: { ...detalleActividad, ...extra }
                            }
                        });
                    } else {
                        // Modo edición
                        abrirEditarActividadDetalle({ ...detalleActividad, ...extra }, isVer);
                    }
                },
                { idDetalleActividad: detalleActividad.idDetalleActividad }
            );
        else abrirEditarActividadDetalle(detalleActividad, isVer);
    };
    const abrirEliminarCambio = (detalleActividad) => {
        let texto = `¿Estás seguro de eliminar el material ${detalleActividad.titulo}? No será considerada al tomar el curso.`;
        let status = -1;

        setConfirm({
            open: true,
            text: texto,
            aceptar: () => {
                setCargando({ open: true });

                serviciosCursos.cambiarEstatusActividadDetatalle(
                    (nuevaData) => {
                        const detalle = nuevaData.detalleActividad;
                        quitaData(detalle[0]);
                        setCargando({ open: false });
                        setConfirm({ open: false });
                        if (window.recargarCursoDatos) {
                            window.recargarCursoDatos();
                        }
                    },
                    { idDetalleActividad: detalleActividad.idDetalleActividad, estatus: status, idActividad: actividad.idActividad }
                );
            }
        });
    };

    const abrirConfirmarCambio = (detalleActividad) => () => {
        let texto = `¿Estás seguro de volver a activar el material ${detalleActividad.titulo}?`;
        let status = 1;
        if (detalleActividad.estatus === '1') {
            texto = `¿Estás seguro de desactivar el material ${detalleActividad.titulo}? No será considerada al tomar el curso.`;
            status = 0;
        }
        setConfirm({
            open: true,
            text: texto,
            aceptar: () =>
                serviciosCursos.cambiarEstatusActividadDetatalle(
                    (nuevaData) => {
                        actualizarDataV2(nuevaData.detalleActividad);
                        setConfirm({ open: false });
                    },
                    { idDetalleActividad: detalleActividad.idDetalleActividad, estatus: status, idActividad: actividad.idActividad }
                )
        });
    };
    const abrirPreguntas = (detalleActividad) => {
        serviciosCursos.getActividadPregunta(
            (res) =>
                setModal({
                    open: true,
                    titulo:
                        detalleActividad.idTipoActividad == 3 || detalleActividad.idTipoActividad == 10
                            ? `Preguntas del examen "${detalleActividad.titulo}"`
                            : `Preguntas de la encuesta "${detalleActividad.titulo}"`,
                    formulario: ModalPreguntasActividad,
                    propsModal: {
                        permisos: permisos,
                        detalleActividad: { ...detalleActividad, preguntas: res.preguntas }
                    }
                }),
            { idDetalleActividad: detalleActividad.idDetalleActividad }
        );
    };
    const cerrarModalCurso = () => setModal({ ...detalleActividad, open: false });

    const guardarDependencia = (dependenciaSelected, regSelected) => (event) => {
        const dataSend = {
            dataSelected: dependenciaSelected,
            idActividad: actividad.idActividad,
            idDetalleActividad: regSelected.idDetalleActividad
        };
        serviciosCursos.guardarDependenciaDetalle((res) => {
            setDetalleActividad(res.detalleActividad);
            cerrarModalCurso();
        }, dataSend);
    };

    const openFormDependencia = (selected) => {
        setModal({
            open: true,
            titulo: 'Agregar dependencias',
            formulario: FormDependenciaDetalle,
            propsModal: {
                data: {
                    selected: selected,
                    allData: detalleActividad.filter((det) => det.idDetalleActividad != selected.idDetalleActividad),
                    columnKey: 'idDetalleActividad'
                },
                headers: headers(() => {}, { estatusCurso: null }, null).detalleActividad,
                guardarDependencia: guardarDependencia,
                cerrar: cerrarModalCurso
            }
        });
    };

    // Config
    const acciones = [
        { label: 'Nuevo material', icon: <AddBox />, click: abrirNuevoMaterial, disabled: !permisos.crear },
        { label: 'Ordenar material', icon: <Reorder />, click: abrirOrdenar, disabled: !permisos.editar }
    ];
    const accionesFila = [
        { label: 'Editar', onClick: (data) => traerDatosExtra(data), enabled: (row) => row.estatus == '1' && permisos.editarActividad },
        {
            label: 'Ver',
            onClick: (data) => traerDatosExtra(data, 1),
            enabled: (row) => ['1', '2', '4', '5', '6', '8', '9'].includes(row.idTipoActividad) && permisos.ver
        },
        {
            label: 'Descargar archivo',
            onClick: descargarMaterialDesdeTabla,
            enabled: (row) => esMaterialTipoArchivo(row.idTipoActividad)
        },
        { label: 'Dependencia', onClick: openFormDependencia, enabled: (row) => row.estatus == '1' && permisos.editar },
        { label: 'Ver Preguntas', onClick: abrirPreguntas, enabled: (row) => ['3', '7', '10', '11'].includes(row.idTipoActividad) },
        { label: 'Eliminar', onClick: abrirEliminarCambio, enabled: true },
        { label: 'Sin opciones', onClick: () => {}, enabled: (row) => row.estatus == 0 && row.idTipoActividad == 1 && !permisos.ver }
    ];

    const columnasDetalleActividad = headers(abrirConfirmarCambio, ctl, permisos).detalleActividad.map((column) => {
        if (column.name !== 'ntipoActividad') return column;

        return {
            ...column,
            type: (row) => {
                const puedeDescargar = esMaterialTipoArchivo(row.idTipoActividad);
                return (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography variant="body2">{row.ntipoActividad || '---'}</Typography>
                        {puedeDescargar && (
                            <Tooltip title={`Descargar archivo "${row?.titulo || 'material'}".`}>
                                <IconButton size="small" color="info" onClick={() => descargarMaterialDesdeTabla(row)}>
                                    <CloudDownload fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                );
            }
        };
    });

    const solicitudesPendientes = descargaActual ? colaDescargas.slice(1) : colaDescargas;

    useEffect(() => {
        if (actividad)
            serviciosCursos.getDetalleActividad(
                (ct) => {
                    setDetalleActividad(ct?.detalleActividad || []);
                    setCtl({ ...ctl, tiposActividad: ct?.tiposActividad || [] });
                },
                { idActividad: actividad.idActividad }
            );
        else setDetalleActividad([]);
    }, [actividad]);
    return (
        <>
            <Tabla
                rows={detalleActividad}
                columns={columnasDetalleActividad}
                accionesTabla={acciones}
                accionesFila={accionesFila}
                columnKey="idDetalleActividad"
            />
            <AvisoConfirmacion
                open={confirm.open}
                title="Advertencia"
                text={confirm.text}
                accept={confirm.aceptar}
                cancel={() => setConfirm({ open: false })}
            />
            <ModalGeneral open={modal.open} width="md" titulo={modal.titulo} OnCerrar={cerrarModalCurso}>
                {modal.formulario && <modal.formulario {...modal.propsModal} />}
            </ModalGeneral>
            <Snackbar
                open={Boolean(descargaActual)}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{
                    maxWidth: 'calc(100vw - 16px)',
                    overflowY: 'hidden',
                    '&::-webkit-scrollbar': { display: 'none' },
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                }}
            >
                <Alert
                    variant="filled"
                    icon={<CircularProgress size={18} color="inherit" />}
                    sx={{
                        alignItems: 'center',
                        backgroundColor: '#0288d1 !important',
                        color: '#FFFFFF',
                        width: 'fit-content',
                        maxWidth: 'min(92vw, 680px)',
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        '& .MuiAlert-icon': { color: '#FFFFFF' },
                        '& .MuiAlert-message': {
                            color: 'inherit',
                            width: '100%',
                            minWidth: 0,
                            overflow: 'hidden',
                            '&::-webkit-scrollbar': { display: 'none' },
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none'
                        },
                        '& .MuiTypography-root': { color: 'inherit' },
                        '& .MuiIconButton-root': { color: '#FFFFFF' },
                        '&::-webkit-scrollbar': { display: 'none' },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none'
                    }}
                    severity="info"
                >
                    <Stack
                        spacing={1}
                        sx={{
                            overflow: 'hidden',
                            '&::-webkit-scrollbar': { display: 'none' },
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none'
                        }}
                    >
                        <Box sx={{ position: 'relative', pr: 4 }}>
                            <Typography
                                variant="body2"
                                sx={{ pr: 1, whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-word' }}
                            >
                                {`Procesando archivo "${descargaActual?.titulo || 'material'}", espere por favor.`}
                            </Typography>
                            <Tooltip title="Cancelar solicitud actual">
                                <IconButton
                                    size="small"
                                    color="inherit"
                                    onClick={cancelarSolicitudActual}
                                    sx={{ position: 'absolute', top: 0, right: 0 }}
                                >
                                    <Close fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        {solicitudesPendientes.length > 0 && (
                            <Stack spacing={0.25}>
                                <Typography variant="subtitle1" sx={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
                                    {`Solicitudes pendientes: ${solicitudesPendientes.length}`}
                                </Typography>
                                {solicitudesPendientes.map((item, index) => (
                                    <Typography
                                        key={`${item.idDetalleActividad}_${index}`}
                                        variant="subtitle2"
                                        sx={{ whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-word' }}
                                    >
                                        {`${index + 1}. "${item?.titulo || 'material'}"`}
                                    </Typography>
                                ))}
                            </Stack>
                        )}
                    </Stack>
                </Alert>
            </Snackbar>
            <Backdrop open={cargando.open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default DetalleActividad;
